(function () {
  'use strict';
  if (window.LatinGinRewards) return;
  var config = window.LatinGinRewardConfig;
  var queue = Promise.resolve();
  var root = config.root;
  function request(path, body) {
    return fetch(root + path, body ? {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify(body)
    } : {headers: {'Accept': 'application/json'}}).then(function (response) {
      if (!response.ok) throw new Error('Reward cart request failed');
      return response.json();
    });
  }
  function subtotal(cart) {
    return cart.items.reduce(function (total, item) {
      return item.properties && item.properties._latin_gin_reward ? total : total + item.final_line_price;
    }, 0);
  }
  function plan(cart) {
    var spend = subtotal(cart);
    var wanted = config.gifts.filter(function (gift) {
      return gift.available && spend >= gift.threshold;
    });
    var seen = {};
    var updates = [];
    cart.items.forEach(function (item) {
      var marker = item.properties && item.properties._latin_gin_reward;
      var legacy = config.legacy.indexOf(item.variant_id) !== -1 && item.final_line_price === 0;
      if (!marker && !legacy) return;
      var gift = wanted.find(function (reward) {
        return reward.key === marker && reward.id === item.variant_id;
      });
      var quantity = gift && !seen[marker] ? 1 : 0;
      if (quantity) seen[marker] = true;
      if (item.quantity !== quantity) updates.push({id: item.key, quantity: quantity});
    });
    var additions = wanted.filter(function (gift) {
      return !seen[gift.key];
    }).map(function (gift) {
      return {id: gift.id, quantity: 1, properties: {_latin_gin_reward: gift.key}};
    });
    return {updates: updates, additions: additions};
  }
  function reconcile() {
    var initialItems;
    return request('cart.js').then(function (cart) {
      initialItems = JSON.stringify(cart.items.map(function (item) { return [item.key, item.quantity, item.final_line_price]; }));
      var next = plan(cart);
      var work = Promise.resolve(cart);
      next.updates.forEach(function (update) {
        work = work.then(function () { return request('cart/change.js', update); });
      });
      if (next.additions.length) {
        work = work.then(function () {
          return request('cart/add.js', {items: next.additions}).catch(function (error) {
            console.error('[LatinGinRewards]', error);
          }).then(function () { return request('cart.js'); });
        });
      }
      return work;
    }).then(function (cart) {
      var charged = cart.items.filter(function (item) {
        return item.properties && item.properties._latin_gin_reward && item.final_line_price > 0;
      });
      var clean = Promise.resolve(cart);
      charged.forEach(function (item) {
        clean = clean.then(function () { return request('cart/change.js', {id:item.key, quantity:0}); });
      });
      return clean;
    }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {cart:cart, latinGinRewards:true}
      }));
      var finalItems = JSON.stringify(cart.items.map(function (item) { return [item.key, item.quantity, item.final_line_price]; }));
      return {cart:cart, changed:finalItems !== initialItems};
    });
  }
  function sync() {
    var job = queue.then(reconcile);
    queue = job.catch(function () {});
    return job.then(function (result) { return result.cart; });
  }
  window.LatinGinRewards = {sync:sync, subtotal:subtotal};
  var timer;
  function refresh(event) {
    if (event.detail && event.detail.latinGinRewards) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var task = window.LatinGinCart ? window.LatinGinCart.refresh() : sync();
      task.catch(function (error) { console.error('[LatinGinRewards]', error); });
    }, 50);
  }
  ['cart:change', 'cart:refresh', 'cart:updated'].forEach(function (name) {
    document.addEventListener(name, refresh);
  });
  var checkoutBusy = false;
  function checkout(event) {
    if (checkoutBusy) { event.preventDefault(); return; }
    var link = event.type === 'click' && event.target.closest('a[href]');
    var form = event.type === 'submit' && event.target;
    var button = event.type === 'click' && event.target.closest('button[name="checkout"],input[name="checkout"]');
    var href = link && link.getAttribute('href');
    var isCheckout = href && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?checkout(?:[/?#]|$)/.test(href);
    if (!isCheckout && !button && !(form && event.submitter && event.submitter.name === 'checkout')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkoutBusy = true;
    sync().then(function () {
      window.location.assign(isCheckout ? href : root + 'checkout');
    }).catch(function (error) {
      checkoutBusy = false;
      console.error('[LatinGinRewards]', error);
    });
  }
  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
  document.addEventListener('DOMContentLoaded', function () {
    var initial = queue.then(reconcile);
    queue = initial.catch(function () {});
    initial.then(function (result) {
      if (config.cartPage && result.changed) window.location.reload();
    }).catch(function (error) { console.error('[LatinGinRewards]', error); });
  });
})();